import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './rules-table.reducer';

export const RulesTableDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const rulesTableEntity = useAppSelector(state => state.rulesTable.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="rulesTableDetailsHeading">
          <Translate contentKey="reachamyApp.rulesTable.detail.title">RulesTable</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{rulesTableEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="reachamyApp.rulesTable.description">Description</Translate>
            </span>
          </dt>
          <dd>{rulesTableEntity.description}</dd>
        </dl>
        <Button tag={Link} to="/rules-table" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/rules-table/${rulesTableEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RulesTableDetail;
